import AppService from "./app-service"

export default class CompanyService extends AppService {

  constructor() {
    super({ path: "companies" })
  }

  getCompany() {
    return this.http.get(this.path).then((companies) => companies[0])
  }  
}